import { t } from 'i18next';
import { ActionStatus, STATUS_COLOR } from '../constants';

interface StatusTagProps {
  status: ActionStatus;
}

export default function StatusTag({ status }: StatusTagProps) {
  const color = STATUS_COLOR[status] ?? '#94a3b8';
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, background: color + '20', color, padding: '3px 10px', borderRadius: 12, fontSize: 11, fontWeight: 600, whiteSpace: 'nowrap', maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis' }}>
      <span style={{ width: 6, height: 6, borderRadius: '50%', background: color, flexShrink: 0 }} />
      {t(`improvementPlan:status.${status}`)}
    </span>
  );
}
